export class MultiTemplateFormsGridBulkWorkflowData {
    public constructor(public formsGridFormFieldId: number, public formInstanceIds: string) {
    }
}
